'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  WebkitTouchCallout: 'none',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  OUserSelect: 'none',
  userSelect: 'none'
};


//////////////////
// WEBPACK FOOTER
// ./~/react-inspector/lib/styles/unselectable.js
// module id = 376
// module chunks = 0 1